"use client";
import React from "react";

import Apply from "./Apply";
import Company from "./company";
import { Pill } from "./details";

import { useJob } from "../_context/JobContext";
import { Skeleton } from "@components/ui/skeleton";

const Aside = ({ role }: { role: string | undefined }) => {
  const { job } = useJob();

  return (
    <aside className="gap-6 col-span-2 hidden flex-col relative md:flex">
      <Company />
      <div className="sticky top-28">
        <div className="p-5 sm:p-6 rounded-lg border ">
          <h1 className="font-semibold text-lg text-neutral-900 mb-3">
            {job.title}
          </h1>
          <ul className="flex flex-wrap gap-2 mb-4">
            {job?.jobType?.jobType ? (
              <Pill>{job?.jobType?.jobType}</Pill>
            ) : null}
            {job?.jobShift?.jobShift ? (
              <Pill>{job?.jobShift?.jobShift}</Pill>
            ) : null}
          </ul>
          {
            role === "CANDIDATE" ? (
              <Apply />
            ) : null
          }
        </div>
      </div>
    </aside>
  );
};

export default Aside;

export const AsideLoading = () => {
  return (
    <aside className="gap-6 col-span-2 hidden flex-col relative md:flex">
      <CompanyLoading />
      <div className="border rounded-lg p-6">
        <Skeleton className="h-7 w-full mb-3" />
        <div className="flex gap-2 mb-4 flex-wrap">
          <Skeleton className="w-20 h-8 rounded-full" />
          <Skeleton className="w-28 h-8 rounded-full" />
        </div>
        <Skeleton className="w-full h-12 rounded-md" />
      </div>
    </aside>
  );
};

export const CompanyLoading = () => {
  return (
    <div className="border rounded-lg p-6">
      <Skeleton className="w-20 sm:w-28 h-20 sm:h-28 rounded-[8px] mx-auto mb-3" />
      <Skeleton className="w-20 h-7 mx-auto mb-3" />
      <div className="space-y-2 mb-3">
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-full h-4" />
      </div>
      <div className="border rounded-lg">
        <Skeleton className="w-full h-[50px]" />
      </div>
    </div>
  );
};
